import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { getApiBase } from "@/lib/httpClient";
import { Input } from "@/components/ui/input";

// Mesmo contrato do BuscaProcesso: o usuário procura pelo nome e o componente
// devolve o cliente inteiro, sem ninguém precisar conhecer o id interno.
export default function BuscaCliente({ onSelect, selecionado, onClear }) {
  const [termo, setTermo] = useState("");
  const [resultados, setResultados] = useState([]);
  const [aberto, setAberto] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const caixa = useRef(null);

  useEffect(() => {
    const fora = (event) => { if (caixa.current && !caixa.current.contains(event.target)) setAberto(false); };
    document.addEventListener("mousedown", fora);
    return () => document.removeEventListener("mousedown", fora);
  }, []);

  useEffect(() => {
    if (selecionado || termo.trim().length < 2) { setResultados([]); return; }
    // Espera a digitação parar: sem isso cada tecla vira uma consulta.
    const timer = setTimeout(async () => {
      setBuscando(true);
      try {
        const { data } = await axios.get(`${getApiBase()}/clientes`, {
          withCredentials: true, params: { search: termo.trim(), limit: 8 },
        });
        setResultados(Array.isArray(data?.items) ? data.items : []);
        setAberto(true);
      } catch {
        setResultados([]);
      } finally {
        setBuscando(false);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [termo, selecionado]);

  if (selecionado) {
    return (
      <div className="flex items-center justify-between gap-2 border border-[#D1DEEE] rounded-md px-3 h-10 bg-[#F4F7FB]">
        <span data-testid="cliente-selecionado" className="text-base text-[#001533] truncate">
          {selecionado.nome}
        </span>
        <button type="button" data-testid="limpar-cliente" onClick={onClear} className="text-[#335480] text-sm hover:text-[#003882]">
          trocar
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={caixa}>
      <Input
        data-testid="busca-cliente"
        value={termo}
        onChange={(event) => setTermo(event.target.value)}
        onFocus={() => resultados.length && setAberto(true)}
        placeholder="Busque pelo nome do cliente"
        autoComplete="off"
      />
      {aberto && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-[#D1DEEE] rounded-md max-h-64 overflow-y-auto">
          {buscando && <p className="p-3 text-base text-[#335480]">Buscando...</p>}
          {!buscando && resultados.length === 0 && (
            <p className="p-3 text-base text-[#335480]">Nenhum cliente encontrado.</p>
          )}
          {resultados.map((cliente) => (
            <button
              key={cliente.cliente_id}
              type="button"
              data-testid={`opcao-cliente-${cliente.cliente_id}`}
              onClick={() => { onSelect(cliente); setAberto(false); setTermo(""); }}
              className="block w-full text-left px-3 py-2 hover:bg-[#F4F7FB]"
            >
              <span className="block text-base text-[#001533]">{cliente.nome}</span>
              <span className="block text-sm text-[#335480]">
                {cliente.document_masked || (cliente.tipo === "fisica" ? "Pessoa física" : "Pessoa jurídica")}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
